import axios from 'axios'
import routerVue from '../router/index'
import {MessageBox,Message,Notification} from 'element-ui'
import QS from 'qs'

let baseUrl = window.location.protocol+process.env.API_URL
console.log(window.location.protocol,baseUrl)
// 环境的切换
// if(process.env.NODE_ENV == 'development') {//dev
//     // 本地接口
//     baseUrl = `${window.location.protocol}//gatewaytest.lechun.cc`
//     axios.defaults.baseURL = baseUrl;
// } else if (window.location.host=='cmscheck.lechun.cc') {//build test
//     baseUrl = `${window.location.protocol}//gatewaytest.lechun.cc`
//     axios.defaults.baseURL = baseUrl;
// } else if (process.env.NODE_ENV == 'debug') {
//     axios.defaults.baseURL = '';
// } else if (process.env.NODE_ENV == 'production') {//build production
//     baseUrl = `${window.location.protocol}//scmapi.lechun.cc`
//     axios.defaults.baseURL = baseUrl;
// }
axios.defaults.baseURL = baseUrl;

axios.defaults.withCredentials = true;
// 请求超时时间
axios.defaults.timeout = 20000;
let catchErr = 0;
//响应拦截器
axios.interceptors.response.use(function (response) {
    console.log('response',response)
    if(response.status != 200){
        console.log('no200',response)
        Notification({
            title:'错误',
            type:'error',
            message:response.data.message||'网络异常,请重试'
        })
    }else{
        console.log('200',response)
        switch (response.data.status){
            case 20112:
                //routerVue.push('/login').catch(err=>err)
                catchErr++
                if(catchErr<=1){
                    let webUrl = window.location.protocol+process.env.LOGIN_URL
                    let returnPage = encodeURIComponent(window.location.href)
                    window.location.href = `${webUrl}/login?auth=1&returnPage=${returnPage}`
                }

                // routerVue.push({
                //         //传递参数使用query的话，指定path或者name都行，但使用params的话，只能使用name指定
                //         path: '/login',
                //         query: {
                //             auth: "0"
                //         }
                //     }
                // );
                break;
            case 500:
                Notification({
                    title:'错误',
                    type:'error',
                    message:response.data.message||'网络异常,请重试'
                })
                break;
            case 40001:
                Notification({
                    title:'错误',
                    type:'error',
                    message:response.data.message||'网络异常,请重试'
                })
                break;

        }
    }
    return response;

}, function (error) {
    console.log(2222,error.response)
    return Promise.reject(error);
});
/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params={}){
    params.pageRouterUrl = params.pageRouterUrl||getRouterPageHash(window.location.hash);
    return new Promise((resolve, reject) =>{

        axios.get(url, {
            params: params
        })
        .then(res => {
            console.log('then',res)
            resolve(res);
        })
        .catch((err,res) => {
            console.log(err,res)
            Notification({
                title:'错误',
                type:'error',
                message:err.message||'网络异常,请重试'
            })

            reject(err)
        })
    });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params={}) {
    params.pageRouterUrl = params.pageRouterUrl||getRouterPageHash(window.location.hash);

    return new Promise((resolve, reject) => {
        axios.post(url, QS.stringify(params))
            .then(res => {
                console.log('then',res)

                resolve(res);
            })
            .catch(err => {
                Notification({
                    title:'错误',
                    type:'error',
                    message:err.message||'网络异常,请重试'
                })
                reject(err)
            })
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postEspec(url, params={}) {
    params.pageRouterUrl = getRouterPageHash(window.location.hash);

    return new Promise((resolve, reject) => {

        axios.post(url, params)
            .then(res => {
                resolve(res);
            })
            .catch(err => {
                Notification({
                    title:'错误',
                    type:'error',
                    message:err.message||'网络异常,请重试'
                })
                reject(err)
            })
    });
}

function getRouterPageHash(hash){
    let regRex = /^#\/(\w)*/g
    let returnUrl = ''
    let hashSet = hash.match(regRex)
    if(hashSet && hashSet[0].split('#/').length>1){
        returnUrl = hashSet[0].split('#/')[1]
    }
    return returnUrl
}
export {baseUrl,getRouterPageHash}



// WEBPACK FOOTER //
// ./src/api/http.js